import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Page } from '@/types/generated';
import { ComponentProps } from '../ComponentResolver/ComponentResolver';
import LazyHydrate from '../LazyHydrate/LazyHydrate';
import { ComponentResolver } from '@shared-components/components/ComponentResolver';
import { ImagePriorityContext } from '@utils/images/imageOptimization';
interface INextPage {
  pageData: Page;
  id?: string;
}
export default function NextPage({
  pageData,
  id
}: Readonly<INextPage>) {
  const {
    contentsCollection,
    pageTitle,
    redirectTo,
    tags
  } = pageData;
  useEffect(() => {
    if (!redirectTo) {
      return;
    }
    const delay = 1;
    const redirectTimeout = setTimeout(() => {
      globalThis.window.location.replace(`${redirectTo}`);
    }, delay);
    return () => clearTimeout(redirectTimeout);
  }, [redirectTo]);
  return <main data-testid="design_system_next_page" id={id} data-sentry-component="NextPage" data-sentry-source-file="NextPage.tsx">
			{pageTitle ? <Grid container alignItems="center" wrap="nowrap">
					<Typography variant="header1" color="primary" data-testid="text_page_title">
						{pageTitle}
					</Typography>
				</Grid> : null}

			{contentsCollection?.items?.map((content, idx) => {
      const entryId = content?.sys?.id ?? 'Unknown entryId';
      if (!content?.__typename) {
        const typenameDescription = content?.__typename ? `: (${content.__typename})` : '';
        console.warn(`NextPage: No content __typename [${typenameDescription}]found for ${entryId}`);
        return null;
      } else if (Object.keys(content).length <= 2) {
        console.warn(`NextPage: Content has too few keys (${Object.keys(content).length}) for ${entryId} as [${content?.__typename ?? 'Unknown typename'}]`);
        return null;
      }
      return <ImagePriorityContext.Provider key={`${content.sys.id}-${content.__typename}-${idx}`} value={idx}>
						{idx > 1 ? <LazyHydrate whenVisible>
								<ComponentResolver data-index={idx} componentProps={content as ComponentProps} typename={content.__typename}
          // tags={tags as Array<string>}
          />
							</LazyHydrate> : <ComponentResolver data-index={idx} componentProps={content as ComponentProps} typename={content.__typename} tags={tags as Array<string>} />}
					</ImagePriorityContext.Provider>;
    }) ?? null}
		</main>;
}